var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgContract = function SvgContract(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M12.7 2H9.9A2 2 0 0 0 8 .7 2 2 0 0 0 6.1 2H3.3C2.6 2 2 2.6 2 3.3V14c0 .7.6 1.3 1.3 1.3h9.4c.7 0 1.3-.6 1.3-1.3V3.3c0-.7-.6-1.3-1.3-1.3M8 2c.4 0 .7.3.7.7 0 .3-.3.6-.7.6a.7.7 0 0 1-.7-.6c0-.4.3-.7.7-.7m4 12H4a.7.7 0 0 1-.7-.7V4c0-.4.3-.7.7-.7h.7V4c0 .7.6 1.3 1.3 1.3h4c.7 0 1.3-.6 1.3-1.3v-.7h.7c.4 0 .7.3.7.7v9.3c0 .4-.3.7-.7.7"
  })));
};
export default SvgContract;